enum StorageFileType {
    all = 'all',
    csv = 'csv',
    pdf = 'pdf',
    doc = 'doc',
    xls = 'xls',
    ppt = 'ppt',
}

export default StorageFileType;
